<template>
	<v-container>
		<v-card
			max-width="600"
			class="mx-auto"
		>
			<v-toolbar
				color="green darken-2"
				dark
			>
				<v-toolbar-title @click="showFolder = true">
					<a style="color: white"> {{tittleFileMenu}} </a>
				</v-toolbar-title>

				<v-spacer></v-spacer>

				<v-scroll-x-transition>
					<v-dialog
						v-if="!showFolder"
						ref="dialog"
						v-model="modal"
						:return-value.sync="date"
						persistent
						width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
						<v-btn icon>
							<v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
						</v-btn>
						</template>
						<v-date-picker
							v-model="date"
							locale="es-us"
							@input="$refs.dialog.save(date)"
						>
						</v-date-picker>
					</v-dialog>
				</v-scroll-x-transition>
			</v-toolbar>

			<v-list
				subheader
				two-line
			>
				<v-scroll-x-transition>
					<v-list-item-group
						v-if="showFolder"
						v-model="selected"
						color="primary"
					>
						<v-subheader inset>Dispositivos</v-subheader>
							<template v-for="(device, index) in devices">
								<v-list-item :key="device.deviceId">
									<v-list-item-avatar>
										<v-icon
											class="grey lighten-1"
											dark
										>
											mdi-folder
										</v-icon>
									</v-list-item-avatar>

									<v-list-item-content>
										<v-list-item-title v-text="device.name"></v-list-item-title>
										<v-list-item-subtitle v-text="device.name"></v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-divider
									v-if="index < devices.length - 1"
									:key="index"
								></v-divider>
							</template>
					</v-list-item-group>
					<v-row class="text-center align-center" v-else-if="loadDownloadFiles" style="min-height: 150px">
						<v-col>
							<v-progress-circular
								:width="3"
								color="green"
								indeterminate
							></v-progress-circular>
						</v-col>
					</v-row>
					<v-list-item-group
						v-else
						color="primary"
					>
						<v-subheader inset>Archivos {{date | dateFormat}}</v-subheader>
							<div v-if="fileDownload.length === 0" class="text-center" style="min-height: 150px; color: black;">
								No hay archivos a mostrar
							</div>
							<template v-for="(file, index) in fileDownload">
								<v-list-item :key="file.file">
									<v-list-item-avatar>
										<v-icon
											class="grey lighten-1"
											dark
										>
											mdi-file-music
										</v-icon>
									</v-list-item-avatar>

									<v-list-item-content>
										<v-list-item-title> {{ file.ts | hourFormat}} </v-list-item-title>
										<v-list-item-subtitle>File: {{file.file}} Size: {{sizePrefig(file.size)}} </v-list-item-subtitle>
									</v-list-item-content>

									<v-list-item-action>
										<v-btn icon>
											<v-icon color="grey lighten-1" @click="getUrl(file)">mdi-cloud-download</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
								<v-divider
									v-if="index < devices.length - 1"
									:key="index"
								></v-divider>
							</template>
					</v-list-item-group>
				</v-scroll-x-transition>
			</v-list>
		</v-card>
	
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
		data: () => ({
			files: [],
			selected: null,
			deviceFiles: {},
			modal: false,
			date: new Date().toISOString().substr(0, 10),
			showFolder: true,
			isLoading: false
		}),

		computed: {
			tittleFileMenu () {
				return this.showFolder ? 'SoundAnalytics' : `SoundAnalytics/${this.deviceFiles.name}`
			},

			fileDownload () {
				return this.$store.getters.downloadFiles
			},

			downloadUrl () {
				return this.$store.getters.downloadUrl
			},

			loadDownloadFiles () {
				return this.$store.getters.loadDownloadFiles
			},

			loadDownloadUrl () {
				return this.$store.getters.loadDownloadUrl
			},

			availableDevices () {
				return this.$store.getters.devices
			},

			devices () {
				if (this.isAdmin)
					return this.availableDevices
				else
					return this.availableDevices.filter(d => !d.privateAudio)
			},

			user() {
				return this.$store.getters.user
			},

			isAdmin() {
				return this.user.roles.some(e => e.name === "admin")
			},
		},

		watch: {
			selected (val) {
				if (this.selected === undefined)
					return

				this.deviceFiles = this.devices[val]
				this.showFolder = false
				this.viewFiles ()
				this.selected = undefined
			},

			date (val) {
				this.viewFiles ()
			},

			downloadUrl (val) {
				window.open(val, '_blank')
			}
		},

		methods: {
			genRandomIndex (length) {
				return Math.ceil(Math.random() * (length - 1))
			},

			device () {
				const device = this.$store.getters.device(id)

				if ( device === undefined ) 
					return "Unknown Device " + id 

				return this.$store.getters.device(id)["name"]
			},

			viewFiles () {
				const payload = {
					deviceId: this.deviceFiles.deviceId,
					day: this.date,
				}

				this.$store.dispatch('pullDownloadDeviceFiles', payload)
			},

			getUrl (file) {
				const payload = {
					key: file.key
				}

				this.$store.dispatch('getDownloadUrl', payload)
			},

			sizePrefig (bytes) {
				const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
				if (bytes == 0) return '0 Byte'
				const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
				return Math.round(bytes / Math.pow(1024, i), 5) + ' ' + sizes[i]
			}
		},
		
		filters : {
			dateFormat (val) {
				if (!moment(val).isValid())
					return val

				return moment(val).format('LL')
			},

			hourFormat (val) {
				if (!moment(val).isValid())
					return val

				return moment(val).format('LTS')
			},
		},

		created () {
			moment.locale('es-us')
		}
  }
</script>